import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  getPackages,
  savePackages,
} from "../../services/packageService";

export const AddPackageLayer = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const editId = searchParams.get("id");

  const [form, setForm] = useState({
    price: "",
    points: "",
  });

  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    if (editId) loadEditData();
  }, [editId]);

  const loadEditData = async () => {
    const res = await getPackages();
    const existing = res?.data?.find(
      (p) => String(p.id) === String(editId)
    );

    if (existing) {
      setIsEdit(true);
      setForm({
        price: existing.price,
        points: existing.points,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = isEdit
        ? [{ id: editId, ...form }]
        : [{ ...form }];

      const res = await savePackages(payload);

      if (res?.status) {
        toast.success(
          isEdit ? "Package updated" : "Package added"
        );
        navigate("/package-list");
      } else {
        toast.error(res?.errors?.[0] || "Failed");
      }
    } catch {
      toast.error("Server error");
    }

    setLoading(false);
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <h5>{isEdit ? "Update" : "Add"} Package</h5>

          <form onSubmit={handleSubmit}>
            <label className="form-label">Price (₹)</label>
            <input
              type="number"
              className="form-control mb-3"
              value={form.price}
              onChange={(e) =>
                setForm({ ...form, price: e.target.value })
              }
              required
            />

            <label className="form-label">Points</label>
            <input
              type="number"
              className="form-control mb-3"
              value={form.points}
              onChange={(e) =>
                setForm({ ...form, points: e.target.value })
              }
              required
            />

            <button
              className="btn btn-primary w-100"
              disabled={loading}
            >
              {loading
                ? "Please wait..."
                : isEdit
                ? "Update Package"
                : "Add Package"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
